import { FilterProvinceType } from "../../components/pages/dashboard/Filter";
import { httpClayStone } from "../../utils/http-claystone";
import _ from "lodash";

export interface DashBoardParamsType {
  timestamp?: string;
  instrument?: string;
  satellite?: string;
  file_name?: string;
  ct_en?: string;
  re_royin?: string;
  pv_idn?: string;
  ap_idn?: string;
  tb_idn?: string;
  lu_code?: number;
  asian?: number;
  status?: string;
  groupby?: string;
  aggregate?: string;
  sort?: string;
  offset?: number;
  limit?: number;
}

export const FileNameAPI = () => {
  return httpClayStone.get(
    "/api/1.0/resources/hotspots/explore?groupby=file_name",
    undefined,
    true
  );
};

export const DashboardAPI = (
  params: DashBoardParamsType,
  provinces?: FilterProvinceType[]
) => {
  if (provinces && provinces.length > 0) {
    const queryString = provinces
      .map((province) => `pv_idn=${province.ProvinceCode}`)
      .join("&");
    return httpClayStone.get(
      `/api/1.0/resources/hotspots/explore?${queryString}`,
      params,
      true
    );
  } else {
    return httpClayStone.get(
      `/api/1.0/resources/hotspots/explore`,
      params,
      true
    );
  }
};
